module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/premium_mobile_3_2-cebc9b798ab6b833e6cd96691003f6c4.webp";